<template>
  <div class="dynamic-collection-tabs">
    <dynamic-tabs-nav
      :label="navLabel"
      :links="collectionLinks"
      :active-link="activeCollectionHandle"
      @click="changeCollection"
      @select="changeCollection"
    />
    <div v-if="activeCollection" class="dynamic-collection-tabs-content">
      <div class="dynamic-collection-tabs-content-inner">
        <ul class="dynamic-collection-tabs-content-grid">
          <product-grid-item
            v-for="product in activeCollection.products"
            :key="product.id"
            :image-src="product.imageSrc"
            :price="product.price"
            :tags="product.tags"
            :title="product.title"
            :url="product.url"
            :available="product.available"
            :sold-out-label="soldOutLabel"
          />
        </ul>

        <footer>
          <a
            :href="activeCollection.url"
            class="dynamic-collection-tabs-content-cta"
          >
            {{ shopThisCollectionLabel }}

            <svg class="pxl-icon pxl-icon-chevron-right">
              <use xlink:href="#pxl-icon-chevron-right" />
            </svg>
          </a>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import ProductGridItem from './ProductGridItem.vue';
import DynamicTabsNav from './DynamicTabsNav.vue';

export default {
  name: 'DynamicCollectionTabs',
  components: {
    DynamicTabsNav,
    ProductGridItem
  },
  props: {
    collectionsUrl: {
      type: String
    },
    collectionLinks: {
      type: Array
    },
    defaultActiveCollection: {
      type: Object
    },
    navLabel: {
      type: String
    },
    shopThisCollectionLabel: {
      type: String
    },
    soldOutLabel: {
      type: String
    }
  },
  data() {
    return {
      collections: {},
      activeCollectionHandle: null
    };
  },
  computed: {
    activeCollection() {
      if (!this.activeCollectionHandle && this.defaultActiveCollection) {
        return this.defaultActiveCollection;
      }

      return this.collections[this.activeCollectionHandle];
    }
  },
  mounted() {
    const { handle } = this.defaultActiveCollection;

    this.collections[handle] = this.defaultActiveCollection;

    this.activeCollectionHandle = handle;
  },
  methods: {
    changeCollection(handle) {
      const url = `${this.collectionsUrl}/${handle}?view=ajax_dynamic_collection`;

      if (!this.collections[handle]) {
        fetch(url)
          .then((res) => res.json())
          .then((collection) => {
            this.collections[handle] = collection;
            this.activeCollectionHandle = handle;
          })
          .catch((error) => console.error(error));
      } else {
        this.activeCollectionHandle = handle;
      }
    }
  }
};
</script>
